export default "__VITE_ASSET__c898a4e1__"